import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ITemplateRejectedOffer } from 'src/app/models/templates.model';
import { SlideBaseComponent } from 'src/app/shared/slider/slide/slide-base.component';
import { OlPdfAcceptanceComponent } from 'src/app/components/ol-pdf-acceptance/ol-pdf-acceptance.component';
import { PdfService } from 'src/app/services/pdf.service';

@Component({
  selector: 'hr-dynamic-rejected-offer',
  templateUrl: './dynamic-rejected-offer.component.html',
  styleUrls: ['./dynamic-rejected-offer.component.scss'],
})
export class DynamicRejectedOfferComponent extends SlideBaseComponent {
  override initialValue: ITemplateRejectedOffer;
  @ViewChild('olPdfAcceptance') olPdfAcceptance!: OlPdfAcceptanceComponent;

  constructor(private formBuilder: FormBuilder, private pdfService: PdfService) {
    super();
  }

  protected onInit(): void {}
  protected onDestroy(): void {}

  protected initForm(): void {
    this.form = this.formBuilder.group({
      slideName: [null, [Validators.required, Validators.maxLength(20)]],
      title: [null, [Validators.required, Validators.maxLength(40)]],
      description: [null, [Validators.required, Validators.maxLength(1500)]],
      firstImage: [null, [Validators.required]],
      firstImageUrl: [null, [Validators.required]],
    });
  }

  downloadPdf() {
    this.pdfService.downloadPdf(this.olPdfAcceptance);
  }
}
